<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div formArrayName="ownerAdditionnalDetails">
                @for (
                  ownerAdditionnalDetail of ownerAdditionnalDetails.controls;
                  track ownerAdditionnalDetail;
                  let i = $index
                ) {
                  <div class="quotite-container mt-1" [formGroupName]="i">
                    <pr-input-owner
                      formControlName="ownerId"
                      [multiple]="false"
                      [disabled]="true"
                      [derrors]="derrors"
                    ></pr-input-owner>
                    @if (optionsOccupationRisk.length > 0) {
                      <div class="row">
                        <div class="col-md-12">
                          <pr-input-column
                            label="Professions à risque"
                            [derrors]="derrors"
                          >
                            <mat-select formControlName="occupationRiskDetail">
                              @for (
                                option of optionsOccupationRisk;
                                track option
                              ) {
                                <mat-option [value]="option.id">
                                  {{ option.value }}
                                </mat-option>
                              }
                            </mat-select>
                          </pr-input-column>
                        </div>
                      </div>
                    }
                    @if (optionsSportRisk.length > 0) {
                      <div class="row">
                        <div class="col-md-12">
                          <pr-input-column
                            label="Sports à risque"
                            [derrors]="derrors"
                          >
                            <mat-select formControlName="sportRiskDetail">
                              @for (option of optionsSportRisk; track option) {
                                <mat-option [value]="option.id">
                                  {{ option.value }}
                                </mat-option>
                              }
                            </mat-select>
                          </pr-input-column>
                        </div>
                      </div>
                    }
                    <div class="row">
                      <div class="col-md-12">
                        <pr-input-column
                          [label]="
                            'Encours auprès de l\'assureur ' +
                            (product.get('parameters.choosedProductCode')
                              ?.value ?? '')
                          "
                          [derrors]="derrors"
                          [suffix]="'€'"
                        >
                          <input
                            formControlName="outstandingInsuredAmount"
                            type="text"
                            placeholder="200000"
                          />
                        </pr-input-column>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
